<script>
  import { layoutMethods,eventListMethods,eventsComputed, erpUserRolesMethods  } from "@/state/helpers";
  import Swal from "sweetalert2";
  import { getModuleAccess } from '@/router/helper.js'

  /**
   * Event List component
   */
  export default {
    page: {
      title: "Event List"
    },
    components: {
    },
    computed: {
      ...eventsComputed
    },
    data() {
      return {
        title: "Event list",
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        pagination: {
          rows: 10,
          page: 1,
          search: null,
          searchField: null,
          eventId: 0
        },
        searchOptions: [
          {text: 'Search All', value:null},
          {text: 'Name', value:'name'},
          {text: 'Mobile Number', value:'mobile_number'},
          {text: 'Email', value:'email'},
        ],
        eventId: 0,
        event: {
          eventId: null,
          eventImageSrc: "",
          eventName: "",
          eventDescription: "",
          eventMeetingUrl: "",
          eventStartDate: null,
          eventEndDate: null,
          eventStatus: 1,
        },
        tblFields: [
          {
            key: 'name',
            sortable: false
          },
          {
            key: 'mobile_number',
            sortable: false
          },
          {
            key: 'email_address',
            sortable: false
          },
          {
            key: 'action',
            sortable: false
          },
        ],
        attendeeList : [], //temporary
        attendeeModal:{
          rows: 10,
          page: 1,
          search: null,
          searchField: null,
          eventId: 0
        },
        eventsModule: {
          access: {
            update: true
          }
        }
      };
    },
    methods: {
      ...layoutMethods,
      ...eventListMethods,
      ...erpUserRolesMethods,
      viewEvent(eventId) {
        this.getEvent(eventId).then((eventData) => {
          this.event = { ...eventData };
          this.getEventAttendees();
        });
      },
      getEventAttendees(state ='') {
        if(state == 'reset'){
          this.pagination.page = 1;
        }
        this.eventAttendee(this.pagination)
        .then(function(res){
          console.log("check:",res);
        })
        .catch(function(e){
            Swal.fire("Loading Failed!", `${e}`, "error");
        });
      },
      onDisplayChange(type = ''){
        if(type == "modal"){
          console.log(this.attendeeTotalRowsModal,this.attendeeModal.rows,this.attendeesModal.length,(this.attendeesModal.length < this.attendeeTotalRowsModal && this.attendeesModal.length != this.attendeeModal.rows));
          if(
            (this.attendeesModal.length < this.attendeeTotalRowsModal && this.attendeesModal.length != this.attendeeModal.rows) || // condition for incrementing display per page
            (this.attendeesModal.length == this.attendeeTotalRowsModal && this.attendeeModal.rows < this.attendeesModal.length) // condition for decreasing display per page
            ){
            this.attendeeModal.page=1;
            this.findAttendees()
          }
          return;
        }
        console.log(this.attendeeTotalRows,this.pagination.rows,this.attendees.length,(this.attendees.length < this.attendeeTotalRows && this.attendees.length != this.pagination.rows));
        if(
          (this.attendees.length < this.attendeeTotalRows && this.attendees.length != this.pagination.rows) || // condition for incrementing display per page
          (this.attendees.length == this.attendeeTotalRows && this.pagination.rows < this.attendees.length) // condition for decreasing display per page
          ){
          this.pagination.page=1;
          this.getEventAttendees()
        }
      },
      refresh(){
        // this.pagination=  {
        //   rows: 10,
        //   page: 1,
        //   search: null,
        //   searchField: null,
        //   eventId: this.eventId
        // },
        this.getEventAttendees();
      },
      removeAttendee(data){
        if (!this.eventsModule.access.update) {
          Swal.fire(
            "Access Restricted",
            "You are not allowed to remove an attendee.",
            "warning"
          );
        } else {
          console.log(">> data:",data);
          var uname = !this.isEmpty(data.name)?data.name:(!this.isEmpty(data.cognito_sub)?data.cognito_sub:data.id);
          Swal.fire({
              title: 'Are you sure?',
              text: "you want to remove "+uname+"?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                // alert("do delete feature");
                this.deleteAttendee(data.id)
                .then(() => {
                  Swal.fire("Successfully Removed!", `${uname} has been removed.`, "success");
                  this.getEventAttendees();
                })
                .catch(() => {
                  Swal.fire("Removing Failed!",`${uname} was not remove.`, "danger");
                });
              }else{
                  return;
              }
          })
        }
      },
      findAttendees(state=''){
        this.attendeeModal.eventId = this.eventId;
        // alert("find attendee");
        if(state == 'reset'){
          this.attendeeModal.page = 1;
        }
        this.getAttendee(this.attendeeModal)
        .then(function(res){
          console.log("check:",res);
        })
        .catch(function(e){
            Swal.fire("Loading Failed!", `${e}`, "error");
        });
      },
      addAttendees(data){
        console.log(">> DATA:", JSON.stringify(data));
        data['eventId'] = this.eventId;
        var uname = !this.isEmpty(data.name)?data.name:(!this.isEmpty(data.cognito_sub)?data.cognito_sub:data.id);
        this.addAttendee(data)
        .then(() => {
          Swal.fire(
            "Added Successful!",
            `${uname} has been added.`,
            "success"
          );
          this.findAttendees('reset');
          this.getEventAttendees('reset');
        })
        .catch((e) => {
          console.log("Err::",e);
          Swal.fire(
            "Adding Failed!",
            Object.prototype.hasOwnProperty.call(e, "message")? e.message : `${uname} was not added.`,
            "error"
          );
        });
      },
      closeModal(modal){
        this.$bvModal.hide(modal)
      },
      openModal(modal=''){
        this.attendeeModal={
          rows: 10,
          page: 1,
          search: null,
          searchField: null,
          eventId: 0
        }
        this.findAttendees();
        this.$bvModal.show(modal)
      },
      isEmpty(value){
          return (
          // null or undefined
          (typeof value == "undefined") || 
          (value == undefined) ||
          (value == null) ||
          (value === "") ||
          // has length and it's zero
          (Object.prototype.hasOwnProperty.call(value,'length') && value.length === 0) ||
          // is an Object and has no keys
          (value.constructor === Object && Object.keys(value).length === 0)
          )
      }
    },
    async mounted(){
      this.changeTitle({title: 'Attendee'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Event List', to: { name: 'Event List'} },
          { text: 'Event Attendee', to: { name: 'Event Details'} }
        ]
      });
      this.eventId = this.$route.params.id;
      this.pagination.eventId = this.$route.params.id;
      if (this.eventId > 0) {
        this.viewEvent(this.eventId);
      }

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Utilities', 'Events')
        .then((access) => this.eventsModule.access = access);
        
    }
  }
    
</script>
<style>
.card-img-top {
    width: 100%;
    height: 15vw;
    object-fit: contain;
}
.c-pointer{
  cursor: pointer;
}
</style>
<template>
  <div><!-- outer div-->
      <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <img 
                class="card-img-top" alt="Card image cap" :src="event.eventImageSrc"
                @error="(e) => e.target.src = require('@/assets/images/img-placeholder.png')"
                >
              <div class="card-body">
                <h5 class="card-title text-capitalize mb-2">{{event.eventName}}</h5>
                <p class="card-text mb-2">
                  <i class="bx bx-calendar text-primary"></i> Start Event: {{event.eventStartDate | formatDateNoComma}}  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <i class="bx bx-calendar text-secondary"></i> End Event: {{event.eventEndDate | formatDateNoComma}}
                </p>
                <p class="card-text">{{event.eventDescription}}</p>
              </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row mb-3">
                        <div class="col-md-4 col-sm-4">
                            <div class="my-2">
                                <h5 class="card-title text-dark">
                                    Attendee: <span class="fw-normal ms-lg-2">{{attendeeTotalRows}}</span>
                                </h5>
                            </div>
                        </div>
                        <!-- end col record display--> 
                        <div class="col-md-8 col-sm-3"> 
                            <div class="d-flex justify-content-lg-end mb-lg-3">
                                <button v-if="eventsModule.access.update" class="btn btn-primary me-2" @click="openModal('bv-modal-add-attendee')">
                                    <i class="uil uil-plus me-1"></i> Add Attendees
                                </button>

                                <a class="btn btn-secondary" @click="refresh">
                                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather> Refresh
                                </a>
                            </div>
                        </div>
                        <div class="col-sm-6 ta-right">
                            <b-form-group description="Search Keyword">
                              <form class="d-flex"  @submit.prevent="getEventAttendees('reset')"  >
                                <b-form-group id="input-group-3" label-for="input-3">
                                  <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                                    id="input-3"
                                    v-model="pagination.searchField"
                                    :options="searchOptions"
                                  ></b-form-select>
                                </b-form-group>

                                <b-input-group>
                                  <b-form-input v-model="pagination.search" class="rounded-0"></b-form-input>
                                  <b-input-group-append>
                                    <b-button variant="primary" type="submit" class="rounded-0 rounded-end px-2">
                                      <i class='bx bx-search bx-fw'></i>
                                    </b-button>
                                  </b-input-group-append>
                                </b-input-group>
                              </form>
                            </b-form-group>
                        </div>
                        <div class="col-sm-6"></div>
                        <div class="col-sm-12">
                          <!-- table responsive -->
                          <div class="table-responsive">
                            <div class="table align-middle table-nowrap">
                              <b-table
                                :items="attendees"
                                :fields="tblFields"
                                responsive="sm"
                              >

                                <template #cell(name)="data">
                                  <span>{{!isEmpty(data.item.name)?data.item.name:(!isEmpty(data.item.cognito_sub)?data.item.cognito_sub:'-')}}</span>
                                </template>
                                <template #cell(mobile_number)="data">
                                  <span>{{data.item.mobile_number}}</span>
                                </template>
                                <template #cell(email_address)="data">
                                  <span>{{data.item.email}}</span>
                                </template>
                                <template #cell(action)="data">
                                  <div class="d-flex">
                                    <div class="btn-group me-2 mb-2 mb-sm-0" :disabled="!eventsModule.access.update">
                                      <span class="text-primary c-pointer" @click="removeAttendee(data.item)">
                                        REMOVE
                                      </span>
                                    </div>
                                  </div>
                                </template>
                              </b-table>
                            </div>
                          </div>
                          <div class="row g-0 text-center" v-if="attendeeTotalRows == 0">
                            <span>No data to display.</span>
                          </div>
                          <div class="row g-0 text-center text-sm-start">
                            <!-- end col -->
                            <div class="col-sm-12"  v-if="attendeeTotalRows != 0 && attendeeTotalRows > 10">
                              <div class="row">
                                <div class="col">
                                  <div class="form-group row pull-left">
                                    <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                                    <div class="col-sm-6">
                                      <b-form-group label-for="display-record">
                                        <b-form-select class="form-select shadow-none w-fit"
                                          id="display-record"
                                          v-model="pagination.rows"
                                          :options="pageOptions"
                                          @change="onDisplayChange()"
                                        ></b-form-select>
                                      </b-form-group>
                                    </div>
                                  </div>
                                  <div
                                    class="
                                      dataTables_paginate
                                      paging_simple_numbers
                                      float-end
                                    "
                                  >
                                    <!-- pagination -->
                                    <b-pagination  v-if="attendeeTotalRows != 0 && attendeeTotalRows > 6 && attendeeTotalRows > pagination.rows"
                                      class="pagination-rounded"
                                      v-model="pagination.page"
                                      @input="getEventAttendees"
                                      :total-rows="attendeeTotalRows"
                                      :per-page="pagination.rows"
                                    ></b-pagination>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- end col -->
                          </div>
                        </div><!--end of col-12-->
                        <!-- end col menus -->
                    </div>
                </div>
                <!-- end card body -->
            </div>

            <!-- add attendee -->
            <b-modal id="bv-modal-add-attendee" title="Add Attendees" size="lg" hide-footer hide-header-close>
              <div class="my-2">
                  <h5 class="card-title text-dark">
                      <span class="fw-normal ms-lg-2"> {{attendeeTotalRowsModal}} </span> Record(s)
                  </h5>
              </div>
              <form class="px-4 py-3 d-flex" @submit.prevent="findAttendees()">
                <b-form-group id="input-group-3" label-for="input-3">
                  <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:fit-content"
                    id="input-3"
                    v-model="attendeeModal.searchField"
                    :options="searchOptions"
                  ></b-form-select>
                </b-form-group>

                <b-input-group>
                  <b-form-input v-model="attendeeModal.search" class="rounded-0"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" type="submit" class="rounded-0 rounded-end px-2">
                      <i class='bx bx-search bx-fw'></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </form>
              <div class="row">
                <div class="col-sm-12">
                  <!-- table responsive -->
                  <div class="table-responsive">
                    <div class="table align-middle table-nowrap">
                      <b-table
                        :items="attendeesModal"
                        :fields="tblFields"
                        responsive="sm"
                      >

                        <template #cell(name)="data">
                          <span>{{!isEmpty(data.item.name)?data.item.name:(!isEmpty(data.item.cognito_sub)?data.item.cognito_sub:'-')}}</span>
                        </template>
                        <template #cell(mobile_number)="data">
                          <span>{{data.item.mobile_number}}</span>
                        </template>
                        <template #cell(email_address)="data">
                          <span>{{data.item.email}}</span>
                        </template>
                        <template #cell(action)="data">
                          <div class="d-flex">
                            <div class="btn-group me-2 mb-2 mb-sm-0">
                              <span class="text-primary c-pointer" @click="addAttendees(data.item)">
                                ADD
                              </span>
                            </div>
                          </div>
                        </template>
                      </b-table>
                    </div>
                  </div>
                  <div class="row g-0 text-center" v-if="attendeeTotalRowsModal == 0">
                    <span>No data to display.</span>
                  </div>
                  <div class="row g-0 text-center text-sm-start">
                    <!-- end col -->
                    <div class="col-sm-12"  v-if="attendeeTotalRowsModal != 0 && attendeeTotalRowsModal > 10">
                      <div class="row">
                        <div class="col">
                          <div class="form-group row pull-left">
                            <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                            <div class="col-sm-6">
                              <b-form-group label-for="display-record">
                                <b-form-select class="form-select shadow-none w-fit"
                                  id="display-record"
                                  v-model="attendeeModal.rows"
                                  :options="pageOptions"
                                  @change="onDisplayChange('modal')"
                                ></b-form-select>
                              </b-form-group>
                            </div>
                          </div>
                          <div
                            class="
                              dataTables_paginate
                              paging_simple_numbers
                              float-end
                            "
                          >
                            <!-- pagination -->
                            <b-pagination  v-if="attendeeTotalRowsModal != 0 && attendeeTotalRowsModal > 6 && attendeeTotalRowsModal > attendeeModal.rows"
                              class="pagination-rounded"
                              v-model="attendeeModal.page"
                              @input="findAttendees"
                              :total-rows="attendeeTotalRowsModal"
                              :per-page="attendeeModal.rows"
                            ></b-pagination>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- end col -->
                  </div>
                </div><!--end of col-12-->
              </div><!--end of row-->
              <div class="text-end mt-4">
                <b-button
                  variant="light"
                  class="w-sm"
                  @click="closeModal('bv-modal-add-attendee')"
                  >Close</b-button
                >
              </div>

            </b-modal>
            <!-- end card -->
          </div><!-- end col-lg-12 -->
      </div><!-- end of row-->
  </div> <!-- end of outer div-->
</template>